<div class="items-center justify-center">
  <div id="default-modal" *ngIf="noConfirmed" tabindex="-1"
    class="bg-opacity-70 bg-gray-400 overflow overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex">
    <div class="relative p-4 w-full max-w-2xl max-h-full">
      <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
        <div class="p-4 md:p-5 space-y-4">
          <div class="flex justify-center items-center">
            <img src="assets/icons/Icon_succes.jpg" alt="" />
          </div>
          <div class="flex justify-center items-center">
            <h1>Succès!</h1>
          </div>
          <div class="justify-center items-center">
            <!-- <p
              class="text-xl text-center leading-relaxed text-gray-500 dark:text-gray-400"
            >
              Votre admission a bien été prise en compte. Afin d'accéder à votre
              espace personnel, vous recevrez un email de réinitialisation de
              votre mot de passe.
            </p> -->
            <p *ngIf="isNewInFODE" class="text-xl text-center leading-relaxed text-gray-500 dark:text-gray-400">
              Votre Admission a bien été prise en compte. Afin d'accéder à votre
              espace FODE, vous recevrez un autre email pour definir votre
              mot de passe.
            </p>
            <p *ngIf="isOldInFODE" class="text-xl text-center leading-relaxed text-gray-500 dark:text-gray-400">
              Votre Admission a bien été prise en compte. Cliquer sur le lien
              suivant et renseigner vos paramètres de connexion pour accéder à
              votre Espace
              <span class="underline text-blue-800">
                <a href="https://fode.force-n.sn/fode" target="_blank">FODE</a>
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="confirmed" tabindex="-1" aria-hidden="true"
    class="bg-opacity-70 bg-gray-400 overflow overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex">
    <div class="relative p-4 w-full max-w-2xl max-h-full">
      <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
        <div class="p-4 md:p-5 space-y-4 items-center justify-center">
          <div class="flex justify-center items-center">
            <img src="assets/icons/Icon-Gris.jpg" alt="" />
          </div>
          <div class="flex justify-center items-center">
            <p *ngIf="isNewInFODE" class="text-xl text-center leading-relaxed text-gray-500 dark:text-gray-400">
              Votre Admission a bien été prise en compte. Afin d'accéder à votre
              espace FODE, vous recevrez un email de réinitialisation de votre
              mot de passe.
            </p>
            <p *ngIf="isOldInFODE" class="text-xl text-center leading-relaxed text-gray-500 dark:text-gray-400">
              Votre Admission a bien été prise en compte. Cliquer sur le lien
              suivant et renseigner vos paramètres de connexion pour accéder à
              votre Espace
              <span class="underline text-blue-800">
                <a href="https://fode.force-n.sn/fode" target="_blank">FODE</a>
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="serverError" tabindex="-1" aria-hidden="true"
    class="bg-opacity-70 bg-gray-400 overflow overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex">
    <div class="relative p-4 w-full max-w-2xl max-h-full">
      <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
        <div class="p-4 md:p-5 space-y-4 items-center justify-center">
          <div class="flex justify-center items-center">
            <img src="assets/icons/Icon-Gris.jpg" alt="" />
          </div>
          <div class="flex justify-center items-center">
            <p class="text-xl text-center leading-relaxed text-gray-500 dark:text-gray-400">
              Nous rencontrons actuellement des difficultés à confirmer votre
              admission. Merci de réessayer plus tard.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Expiration modal -->
</div>